import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('utilisateur');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
export const authService = {
  login: (data) => api.post('/auth/login', data),
  moi: () => api.get('/auth/moi'),
  changerMotDePasse: (data) => api.put('/auth/mot-de-passe', data),
  changerEmail: (data) => api.put('/auth/email', data),
  getPreferences: () => api.get('/auth/preferences'),
  updatePreferences: (data) => api.put('/auth/preferences', data),
  mettreAJourProfil: (data) => api.put('/auth/profil', data),
  creerUtilisateur: (data) => api.post('/auth/creer', data),
  demanderReinitialisation: (email) => api.post('/auth/mot-de-passe-oublie', { email }),
  reinitialiserMotDePasse: (token, nouveau_mot_de_passe) => api.post('/auth/reinitialiser-mot-de-passe', { token, nouveau_mot_de_passe }),
};
export const utilisateursService = {
  soumettreOnboarding: (data) => api.put('/utilisateurs/moi/onboarding', data),
};
export const projetsService = {
  getAll: () => api.get('/projets'),
  getOne: (id) => api.get(`/projets/${id}`),
  create: (data) => api.post('/projets', data),
  update: (id, data) => api.put(`/projets/${id}`, data),
  getAVenir: () => api.get('/projets/a-venir'),
  getDashboardTechnicien: () => api.get('/projets/moi/technicien/dashboard'),
  getMesProjetsTechnicien: () => api.get('/projets/moi/technicien'),
};
export const reservationsService = {
  mesReservations: () => api.get('/reservations/moi'),
  reserver: (projetId, data) => api.post(`/reservations/${projetId}`, data),
  annuler: (id) => api.delete(`/reservations/${id}`),
  parProjet: (projetId) => api.get(`/reservations/projet/${projetId}`),
};
export const lotsService = {
  getAll: (projetId) => api.get(`/lots?projet_id=${projetId}`),
  getOne: (id) => api.get(`/lots/${id}`),
  create: (data) => api.post('/lots', data),
  update: (id, data) => api.put(`/lots/${id}`, data),
  ajouterMortalite: (data) => api.post('/lots/mortalite', data),
  // Sélection de reproducteurs en cours de projet — extraction définitive du
  // pool générique du lot, jamais recréditée quel que soit le statut ultérieur.
  extraireReproducteurs: (lotId, data) => api.post(`/lots/${lotId}/reproducteurs`, data),
  getReproducteurs: (lotId) => api.get(`/lots/${lotId}/reproducteurs`),
  activerVente: (lotId) => api.put(`/lots/${lotId}/activer-vente`),
  getDisponiblesVente: () => api.get('/lots/disponibles-vente'),
  transferer: (lotId, data) => api.post(`/lots/${lotId}/transferer`, data),
  sexer: (lotId, data) => api.put(`/lots/${lotId}/sexer`, data),
};
export const rapportsService = {
  getAll: (projetId) => api.get(`/rapports?projet_id=${projetId}`),
  getOne: (id) => api.get(`/rapports/${id}`),
  getComplet: (id) => api.get(`/rapports/${id}/complet`),
  modifier: (id, data) => api.put(`/rapports/${id}/modifier`, data),
  create: (data) => api.post('/rapports', data),
  delete: (id) => api.delete(`/rapports/${id}`),
  validerT1: (id) => api.put(`/rapports/${id}/valider-t1`),
  validerGestionnaire: (id) => api.put(`/rapports/${id}/valider`),
  refuser: (id, motif) => api.put(`/rapports/${id}/refuser`, { motif }),
  envoyer: (id) => api.post(`/rapports/${id}/envoyer`),
  validerTechnicien: (id) => api.put(`/rapports/${id}/valider-technicien`),
  refuserTechnicien: (id, commentaire) => api.put(`/rapports/${id}/refuser-technicien`, { commentaire }),
  getAValiderStagiaires: () => api.get('/rapports/a-valider-stagiaires'),
};
export const monParcoursService = {
  get: () => api.get('/mon-parcours'),
};
export const depensesService = {
  getAll: (projetId) => api.get(`/depenses?projet_id=${projetId}`),
  // Page paginée (défilement infini) — la liste seule, PAS les totaux (voir getTotaux).
  getPage: (projetId, { limit, offset }) => api.get(`/depenses?projet_id=${projetId}&limit=${limit}&offset=${offset}`),
  // Toujours exacts (calculés en SQL), indépendants de la pagination.
  getTotaux: (projetId) => api.get(`/depenses/totaux?projet_id=${projetId}`),
  create: (data) => api.post('/depenses', data),
  update: (id, data) => api.put(`/depenses/${id}`, data),
  delete: (id) => api.delete(`/depenses/${id}`),
  // Lignes de devis
  getLignesDevis: (depenseId) => api.get(`/depenses/${depenseId}/devis`),
  ajouterLigneDevis: (depenseId, data) => api.post(`/depenses/${depenseId}/devis`, data),
  modifierLigneDevis: (ligneId, data) => api.put(`/depenses/devis/${ligneId}`, data),
  supprimerLigneDevis: (ligneId) => api.delete(`/depenses/devis/${ligneId}`),
  // Historique des paiements
  getPaiements: (depenseId) => api.get(`/depenses/${depenseId}/paiements`),
  ajouterPaiement: (depenseId, data) => api.post(`/depenses/${depenseId}/paiements`, data),
  supprimerPaiement: (paiementId) => api.delete(`/depenses/paiements/${paiementId}`),
  // Répartition entre financeurs
  getRepartition: (depenseId) => api.get(`/depenses/${depenseId}/repartition`),
  ajouterRepartition: (depenseId, data) => api.post(`/depenses/${depenseId}/repartition`, data),
  getPaiementsRepartition: (repartitionId) => api.get(`/depenses/repartition/${repartitionId}/paiements`),
  ajouterPaiementRepartition: (repartitionId, data) => api.post(`/depenses/repartition/${repartitionId}/paiements`, data),
};
export const ventesService = {
  // Sans projetId : toutes les ventes de l'organisation (gestionnaire
  // uniquement côté serveur), utilisé par Commerce pour l'onglet "Ventes"
  // toutes projets confondus.
  getAll: (projetId) => api.get(projetId ? `/ventes?projet_id=${projetId}` : '/ventes'),
  // Page paginée (défilement infini) — la liste seule, PAS les totaux (voir getTotaux).
  getPage: (projetId, { limit, offset }) => api.get(
    projetId ? `/ventes?projet_id=${projetId}&limit=${limit}&offset=${offset}` : `/ventes?limit=${limit}&offset=${offset}`
  ),
  // Toujours exacts (calculés en SQL), indépendants de la pagination.
  getTotaux: (projetId) => api.get(projetId ? `/ventes/totaux?projet_id=${projetId}` : '/ventes/totaux'),
  create: (data) => api.post('/ventes', data),
  update: (id, data) => api.put(`/ventes/${id}`, data),
  delete: (id) => api.delete(`/ventes/${id}`),
  // Paiements réels — seul point d'entrée qui encaisse en caisse.
  getPaiements: (venteId) => api.get(`/ventes/${venteId}/paiements`),
  ajouterPaiement: (venteId, data) => api.post(`/ventes/${venteId}/paiements`, data),
};
export const investisseursService = {
  getPaiements: (investissementId) => api.get(`/investisseurs/${investissementId}/paiements`),
  ajouterPaiement: (investissementId, data) => api.post(`/investisseurs/${investissementId}/paiements`, data),
};
export const generationsService = {
  getAll: (projetId) => api.get(`/generations?projet_id=${projetId}`),
  getOne: (id) => api.get(`/generations/${id}`),
  getArbre: (id) => api.get(`/generations/${id}/arbre`),
  create: (data) => api.post('/generations', data),
  getMouvementsAnimaux: (id) => api.get(`/generations/${id}/mouvements-animaux`),
  getCouts: (id) => api.get(`/generations/${id}/couts`),
  ajouterCout: (id, data) => api.post(`/generations/${id}/couts`, data),
};
export const liquidationsService = {
  previsualiser: (projetId, params) => api.get(`/liquidations/${projetId}/previsualiser`, { params }),
  liquider: (projetId, data) => api.post(`/liquidations/${projetId}/liquider`, data),
  relancer: (projetId, data) => api.post(`/liquidations/${projetId}/relancer`, data),
  getOne: (projetId) => api.get(`/liquidations/${projetId}`),
};
export const acheteursService = {
  getAll: () => api.get('/acheteurs'),
  create: (data) => api.post('/acheteurs', data),
  update: (id, data) => api.put(`/acheteurs/${id}`, data),
  delete: (id) => api.delete(`/acheteurs/${id}`),
};
export const caissesService = {
  getAll: () => api.get('/caisses'),
  getOne: (id) => api.get(`/caisses/${id}`),
  create: (data) => api.post('/caisses', data),
  getMouvements: (id) => api.get(`/caisses/${id}/mouvements`),
  crediter: (id, data) => api.post(`/caisses/${id}/credit`, data),
  debiter: (id, data) => api.post(`/caisses/${id}/debit`, data),
  virement: (data) => api.post('/caisses/virement', data),
  supprimerMouvement: (id) => api.delete(`/caisses/mouvements/${id}`),
};
export const messagesService = {
  getFil: (investisseurId) => investisseurId ? api.get(`/messages/${investisseurId}`) : api.get('/messages'),
  envoyer: (data) => api.post('/messages', data),
  getConversations: () => api.get('/messages/conversations'),
  getNonLus: () => api.get('/messages/non-lus'),
  envoyerDiffusion: (data) => api.post('/messages/diffusion', data),
};

export const apercuFermeService = {
  getMesProjets: () => api.get('/apercu-ferme/projets'),
  getAgrege: () => api.get('/apercu-ferme/agrege'),
  getProjetDetail: (id) => api.get(`/apercu-ferme/projets/${id}`),
  getComptes: () => api.get('/apercu-ferme/comptes'),
  mettreAJourAcces: (id, data) => api.put(`/apercu-ferme/comptes/${id}`, data),
};
export const liensPublicsService = {
  // Gestion — authentifié, gestionnaire uniquement.
  lister: () => api.get('/liens-publics'),
  creer: (data) => api.post('/liens-publics', data),
  revoquer: (id) => api.put(`/liens-publics/${id}/revoquer`),
  // Consultation publique — aucune authentification, le token fait office de clé.
  getApercuPublic: (token) => api.get(`/liens-publics/public/${token}`),
  getProjetPublic: (token, projetId) => api.get(`/liens-publics/public/${token}/projets/${projetId}`),
};

export default api;